import { useInvestmentsId } from "@rentablo/api/apiv1";
import { useMyself } from "@api/v1/hooks/useMyself";
import { useHistoricQuotesPercent } from "@features/fundamentals/hooks/useHistoricQuotesForInvestment";
import { getFromDate } from "@features/fundamentals/hooks/chartData/getFromDate";
import { HistoricalQuotesBaseChart } from "@components/Chart";

interface Props {
  investmentId: number;
}

export const HistoricalQuotesByInvestmentChart = ({ investmentId }: Props) => {
  const { data: currentUser } = useMyself();
  const { data: investment, isFetching: isInvestmentLoading } =
    useInvestmentsId(
      { id: investmentId! },
      { enabled: investmentId !== undefined }
    );

  const fromDate = currentUser?.isUserPro ? getFromDate() : undefined;

  const { data: historicQuotes, isFetching: isHistoricQuotesLoading } =
    useHistoricQuotesPercent(
      investmentId,
      investment?.tickerSymbolWithCurrency,
      fromDate
    );

  return (
    <HistoricalQuotesBaseChart
      historicQuotes={historicQuotes}
      isFetching={isInvestmentLoading || isHistoricQuotesLoading}
    />
  );
};
